import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate, useI18n } from '@change-corgi/core-react/i18n';

import { PlaceFieldSunrise } from 'src/app/shared/components/googlePlaces';

import { useLocation } from './hooks/useLocation';

export const Location: React.FC = () => {
	const { translate, typedTranslate } = useI18n();
	const { data, actions } = useLocation();

	if (data.geoReach !== 'local') return null;

	return (
		<div id="petition_location" className="flex flex-col">
			<Text variant="body" size="small" className="mb-1">
				<Translate value="corgi.petition.edit.petition_data.location.title" />
			</Text>
			<PlaceFieldSunrise
				label={translate('corgi.petition.edit.petition_data.location.title')}
				labelIsVisible={false}
				geoScope={data.geoReach}
				onSelect={actions.onSelect}
				defaultPlaceValue={data.place}
				error={data.error ? typedTranslate(data.error) : null}
			/>
		</div>
	);
};
